import db from '@/firebase/init'
import firebase from 'firebase';

export default {

    data () {
        return {
          dSites: null,
          iSites: null
        }
    },

    methods: {

        dataInitSites(redirectIfOneSite) {
            if(firebase.auth().currentUser 
                && !( 'dSites' in this.$globalData && Array.isArray(this.$globalData.dSites))
            ) {
                this.$globalData.dSites = false
                var dSites = []
                var iSites = {}
                db.collection("sites").where("roles.admin", "array-contains", firebase.auth().currentUser.uid)
                .get()
                .then((querySnapshot) => {
                    querySnapshot.forEach((doc) => { dSites.push({id: doc.id, name: doc.data().name}) })
                    dSites.sort((a,b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0))
                    for(var i in dSites) { iSites[dSites[i].id] = i }
                    this.$globalData.dSites = dSites
                    this.$globalData.iSites = iSites
                    this.dataFinishSites(redirectIfOneSite)
                })
                .catch((error) => { console.log("sK: Error getting sites: ", error) })
              } else {
                this.dataFinishSites(redirectIfOneSite)
              }
        },

        dataFinishSites(redirectIfOneSite) {
            this.$set(this, 'dSites', this.$globalData.dSites)
            this.$set(this, 'iSites', this.$globalData.iSites)
            if(redirectIfOneSite && this.$globalData.dSites.length == 1) { 
                this.$router.push({name: 'Devices', params: {site: this.$globalData.dSites[0].id}})
            }
        }

    }

}


// WEBPACK FOOTER //
// ./src/mixins/SitesVars.js